import { render, staticRenderFns } from "./SwitchIcon.vue?vue&type=template&id=7ec35814&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ec35814')) {
      api.createRecord('7ec35814', component.options)
    } else {
      api.reload('7ec35814', component.options)
    }
    module.hot.accept("./SwitchIcon.vue?vue&type=template&id=7ec35814&", function () {
      api.rerender('7ec35814', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/assets/icons/SwitchIcon.vue"
export default component.exports